import React from 'react';
import moduleOne_img from '../../../assets/img/moduleOne_img.webp';
import expert_check from '../../../assets/img/expert/expert_check.svg';
import s from '../MainEducation.module.css';

type Props = {
	text: string;
	img: string;
	name: string;
	progress: any;
	completed: any;
};
const MainEducationProgressLineTop: React.FC<Props> = ({
	text,
	img,
	name,
	progress,
	completed,
}) => {
	return (
		<div className="page__module-one module-one">
			<div className={`${s.imageContainer} module-one__img`}>
				<img src={img ?? moduleOne_img} alt={name ?? ''} />
			</div>
			{Boolean(text) && (
				<div className="module-one__item">
					<div className="module-one__label">{text}</div>
					{progress >= 0 && (
						<div className="module-one__proggress">
							{completed && (
								<div className="module-one__icon">
									<img src={expert_check} alt="expert_icon" />
								</div>
							)}
							<div className="module-one__percent">{progress}%</div>
							<div className="module-one__line">
								<span style={{width: progress + '%'}}> </span>
							</div>
						</div>
					)}
				</div>
			)}
		</div>
	);
};

export default MainEducationProgressLineTop;
